// extracted by mini-css-extract-plugin
export default {"wrapper":"Ti2XNrWiuga5BTNv8RQP"};